export default __webpack_public_path__ + "static/media/Asset 7.99fd1f79.png";